import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
   List, ListItemIcon, ListItemText, Typography
} from '@mui/material';
import {
  DragDropContext, Draggable, Droppable
} from 'react-beautiful-dnd'; // Docs : https://github.com/atlassian/react-beautiful-dnd/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { translate } from 'utils';
import { StyledListItem, DeleteButton } from 'components';

const StyledList = styled(List)`
  max-height: 400px;
  overflow-y: auto;
`;

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const ReorderableList = ({
  title, list, onDelete, onReorder
}) => {
  const onDragEnd = useCallback(result => {
    const { destination, source } = result;

    // If the item is dropped outside the list
    if (!destination) {
      return;
    }

    const items = reorder(
      list,
      source.index,
      destination.index
    );

    onReorder(items);
  }, [list, onReorder]);

  return (
    <>
      {list && list.length > 0 && <Typography>{title}</Typography>}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <StyledList ref={provided.innerRef} {...provided.droppableProps}>
              {list.map((item, index) => item && (
                <Draggable draggableId={item.id} index={index} key={item.id}>
                  {prov => (
                    <StyledListItem
                      {...prov.draggableProps}
                      {...prov.dragHandleProps}
                      ref={prov.innerRef}
                    >
                      <ListItemIcon style={{ minWidth: '30px' }}>
                        <>
                          <FontAwesomeIcon icon={faEllipsisV} />
                          <FontAwesomeIcon icon={faEllipsisV} />
                        </>
                      </ListItemIcon>
                      <ListItemText primary={item.title} />
                      {onDelete && (
                      <DeleteButton
                        aria-label={translate('button.delete')}
                        edge="end"
                        onClick={() => onDelete(item)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} size="xs" />
                      </DeleteButton>
                        )}
                    </StyledListItem>
                    )}
                </Draggable>
                ))}
              {provided.placeholder}
            </StyledList>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

ReorderableList.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onDelete: PropTypes.func,
  onReorder: PropTypes.func.isRequired
};

ReorderableList.defaultProps = {
  onDelete: null
};
